module.exports = __webpack_public_path__ + "img/logo.1ac71de7.png";